import React from 'react';

function PolicyDropdown(props) {
    return (
        <div className="policy-dd dropdown-menu show">
            <a className="dropdown-item" href='mailto:support@keenlyhealth.com' onClick={props.handleClose}>Help</a>
            <a className="dropdown-item" target="_blank" onClick={props.handleClose} href="/static-pages/Application_Privacy_Policy_Draft_4-14-2021.pdf">Privacy Policy</a>
        </div>
    );
}

export default PolicyDropdown;
